import { useState, useEffect } from "react";
import { useSearchParams, useLocation, Link } from "react-router-dom";
import LavorisService from "../../services/LavorisService";
import {ApplicantDataType} from "./types_Applicants"
import { EditButton } from "../../components/others/EditButton/index";
import StyledWrapper from "./style";
import ApplicantData from "./ApplicantData";
import EmployeeTurns from "./ApplicantTurns";
import EditApplicantModal from "../others/editApplicant";
import { useModal } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { Button } from "../../components/core/Button";
import { positionsPlaceholder } from "../Turnos/positions";

const EmployeeProfile = () => {

  //useModal() hook
  const { openModal, closeModal, isActive } = useModal()

  //useNavigate
  const navigate = useNavigate()

  //Helper Functions
  let getCurrentTab = () => {
    //Check which page it is on
    const pathname = window.location.pathname;
    let result = pathname.includes("Datos")
      ? "datos"
      : pathname.includes("Turnos")
      ? "turnos"
      : "";
    return result;
  };

  //Lavoris Instance
  const LavorisInstance = LavorisService.getInstance();

  //useLocation Hook
  const location = useLocation();

  // useStates
  const [data, setData] = useState<ApplicantDataType & {nationality: string, maritalStatus: string}>();
  const [searchParams, setSearchParams] = useSearchParams("");
  const [currentTab, setCurrentTab] = useState<any>(() => {
    getCurrentTab();
  });

  //CONSTANTS
  const applicantID = searchParams.get("id") || "";
  const urlParam = applicantID ? `?id=${applicantID}` : "";

  // useEffects
  useEffect(() => {
    const getApplicantProfile = async () => {
      try {
        const individualApplicant =
          await LavorisInstance.CompanyServices.getIndividualApplicant(
            applicantID || "",
          );
        if (individualApplicant) {
          setData(individualApplicant);
        }
      } catch (e) {
        console.log(e);
      }
    };
    getApplicantProfile();
  }, [searchParams]);

  //useEffects
  useEffect(() => {
    setCurrentTab(getCurrentTab());
  }, [location]);

  const formatPosition = (position: string | undefined) => {
    if(!position) return "Postulante"
    const posFiltered = positionsPlaceholder.find((pos) => pos.value === position)
    if(posFiltered) return posFiltered.name
    const pos = position.split("_").join(" ").toLocaleLowerCase()
    return pos
  }

  return (
    <div className="p-0 sm:p-3 bg-white">
      <Button
        type="button"
        className="leading-4 lav-black flex w-full justify-start p-0 pb-4 bg-white border-none"
        onClick={() => navigate(`/Postulantes`)} 
        text={""}>
        <IoIosArrowBack className="text-xl font-normal flex align-center" />
        <span>Volver a listado</span>
      </Button>
      <h2 className="font-bold text-xl fontSize-2xl mb-4">Detalle de Empleado</h2>

      <div className="w-full bg-neutral-100 rounded-lg flex items-center px-8 py-3.5 gap-5 mb-8">
        <div className="w-20 h-20 rounded-full">
          <img src="/images/Profile.svg" alt="" className="bg-white rounded-full drop-shadow-lg" />
        </div>
        <div className="flex flex-col max-w-xs">
          <p className="font-bold text-xl text-black leading-6">{data?.name}</p>
          <p className="font-normal text-xs text-zinc-400 mt-2">
            {data?.positionName}
          </p>
          {/* 
          <p className="font-normal text-xs text-zinc-400 mt-2">
            Tu perfil en Lavoris todavía no está completo. Mejorá la experiencia
            en tu consulta con un profesional y completá la mayor cantidad de
            información posible.
          </p> */}
        </div>
        {/* <div className="ml-auto">
          <EditButton
            text="Editar Datos"
            type="button"
            onClick={() => {
              openModal("modalEditarPostulante", applicantID)
            }}
          />
        </div> */}
      </div>

      <ul className="flex gap-8 mb-7">
        <StyledWrapper.ListItem
          active={currentTab === "datos" ? true : false}
          onClick={() => {
            setCurrentTab("datos");
          }}
        >
          <Link to={`/Perfil/Postulante/Datos${urlParam}`}>Datos personales</Link>
        </StyledWrapper.ListItem>
        {/*<StyledWrapper.ListItem
          active={currentTab === "turnos" ? true : false}
          onClick={() => {
            setCurrentTab("turnos");
          }}
        >
          <Link to={`/Perfil/Postulante/Turnos${urlParam}`}>Turnos y resultados</Link>
        </StyledWrapper.ListItem>*/}
      </ul>

      {/* RENDER CORRECT INFO */}
      {currentTab === "datos" && <ApplicantData employee={data} />}
      {/* {currentTab === "turnos" && <EmployeeTurns />}*/}

      {isActive("modalEditarPostulante") &&
      <EditApplicantModal
        urlTittle={"modalEditarPostulante"}
        onClose={() => {closeModal("modalEditarPostulante")}}
        toggleModal
      />}
    </div>
  );
};
export default EmployeeProfile;
